// extracted by mini-css-extract-plugin
module.exports = {"dataTerm":"DataTerm_dataTerm_1kmw_","half":"DataTerm_half_2qlmI","quater":"DataTerm_quater_2US6j"};